import {commonReduxActionTypes} from './commonRedux.actionTypes';
const initialState = {
  globalConfigData: {appEnabled: true, changeLogs: [], countries: []},
  isHTTShow: true,
  appIdle: true,
  isInitialDynamicLinkFired: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case commonReduxActionTypes.GET_CONFIG: {
      return {
        ...state,
        globalConfigData: action.payload,
      };
    }
    case commonReduxActionTypes.IS_LOGIN_MODAL_SHOW: {
      return {
        ...state,
        isLoginModalShow: action.payload,
      };
    }
    case commonReduxActionTypes.IS_LOADER_SHOW: {
      return {
        ...state,
        isLoaderShow: action.payload,
      };
    }
    case commonReduxActionTypes.GET_FAQ: {
      return {
        ...state,
        faqsData: action.payload,
      };
    }
    case commonReduxActionTypes.SET_IS_LOGIN: {
      return {
        ...state,
        isAppLogin: action.payload,
      };
    }
    case commonReduxActionTypes.SET_APP_PAUSED: {
      return {
        ...state,
        appIdle: true,
      };
    }
    case commonReduxActionTypes.SET_APP_RESUMED: {
      return {
        ...state,
        appIdle: false,
      };
    }
    case commonReduxActionTypes.SET_INITIAL_DYNAMIC_LINK: {
      return {
        ...state,
        isInitialDynamicLinkFired: true,
      };
    }

    default: {
      return state;
    }
  }
};

export {reducer as utilReducer};
